import React, { Component } from 'react';
import PropTypes from 'prop-types';
import jsPDF from 'jspdf/dist/jspdf.min';
import 'whatwg-fetch';

import ContinueFooter from '../../components/ContinueFooter';
import ReactPDF from '../../components/ReactPDF';

import RaisedButton from 'material-ui/RaisedButton';

import certificate from './certificate.pdf';

import './style.css';

// TOOD: https://wiki.base22.com/display/btg/Send+data+to+Google+docs+using+a+web+form+and+AJAX
const GOOGLE_URL = 'https://script.google.com/macros/s/AKfycbzf9HRCg1m0XevrAsv7WiLHkllomHmJdD48IHmuefiM50sW0dQ/exec';

class Certificate extends Component {

  static propTypes = {
    details: PropTypes.shape({
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      phoneNumber: PropTypes.string.isRequired,
    }).isRequired,
  };

  componentDidMount() {
    try {
      const formData = new FormData();

      formData.append('Name', this.props.details.name);
      formData.append('Email', this.props.details.email);
      formData.append('Phone Number', this.props.details.phoneNumber);

      fetch(GOOGLE_URL, { method: 'post', body: formData });
    } catch (e) {
      //
    }
  }

  handleOnPageRender = () => {
    const ctx = this.pdf.canvas.getContext('2d');

    ctx.font = '40px Arial';
    ctx.textAlign = 'center';
    ctx.fillText(this.props.details.name, this.pdf.canvas.width / 2, this.pdf.canvas.height / 2);

    ctx.font = '16px Arial';
    ctx.textAlign = 'center';
    ctx.fillText((new Date()).toDateString(), this.pdf.canvas.width * 0.26, this.pdf.canvas.height * 0.76);
  };

  handlePrintPress = () => {
    window.print();
  };

  handleDownloadPress = () => {
    const pdf = new jsPDF({
      format: 'a4',
      unit: 'px',
      compress: true,
      autoSize: true,
      orientation: 'landscape',
    });

    pdf.addImage(this.pdf.canvas, 'Canvas', 0, -10, 640, 460);
    pdf.save(`IHSAA Concussion Certificate - ${this.props.details.name}.pdf`);
  };

  render() {
    return (
      <div className="Certificate printable">
        <ReactPDF
          className="printable"
          file={certificate}
          onPageRender={this.handleOnPageRender}
          ref={(pdf) => {
            this.pdf = pdf;
          }}
        />

        <ContinueFooter
          continueLabel="Download Certificate"
          onContinue={this.handleDownloadPress}
        >
          <RaisedButton
            primary
            label="Print Certificate"
            onTouchTap={this.handlePrintPress}
          />
        </ContinueFooter>
      </div>
    );
  }
}

export default Certificate;


// WEBPACK FOOTER //
// ./src/containers/Certificate/index.js